export const removeMedFromPacketsDefault = '{\n' +
    '    "contractId": ""\n' +
    '    "programName": "AP_PILLPACK"\n' +
    '    "version": ""\n' +
    '    "itemManipulationEntityAction": "REMOVE"\n' +
    '    "drugId": ""\n' +
    '}';

export interface IRemoveMedFromPacketsRequest {
    contractId: string
    programName: string
    version: string
    itemManipulationEntityAction: string
    drugId: string
}
